export default "__VITE_ASSET__CFccP_nZ__"